import type { SVGProps } from 'react';
const SvgShortText = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#short_text_svg__a)">
      <path fill="currentColor" d="M4 9h16v2H4V9Zm0 4h10v2H4v-2Z" />
    </g>
    <defs>
      <clipPath id="short_text_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgShortText;
